import React from "react";
import { Link } from "react-router-dom";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Sidenav() {
  return (
    <div className="h-full hidden md:block md:w-64 w-16 md:transition-all md:duration-300 md:mt-16 md:shadow-md bg-gray-800">
      

      <div className="md:w-64 hidden md:block">
        
        <ul className="mt-2">
          <SubMenu to="/admin/home" text=" Dashboard" />
          <MenuItem to="/admin/home" text=" Home" />
          <SubMenu text="Products">
            <MenuItem to="/admin/products" text="All Products" />
            <MenuItem to="/admin/cake" text="Cake" />
            <MenuItem to="/admin/special" text="Special" />
            {/* Add more product-related menu items as needed */}
          </SubMenu>

          <SubMenu text="Orders">
            <MenuItem to="/admin/orders" text="All Orders" />
            <MenuItem to="/admin/pending" text="Pending Product" />
            <MenuItem to="/admin/complete" text="Complete Product" />
            {/* Add more product-related menu items as needed */}
          </SubMenu>
          {/* Contact Us  */}
          <SubMenu text="Contact">
            <MenuItem to="/admin/contact" text="Get Contact" />
            
            {/* Add more product-related menu items as needed */}
          </SubMenu>
          {/* Add more menu items as needed */}
        </ul>
      </div>
      
    </div>
  );
}

const MenuItem = ({ to, text }) => (
  <li className="mb-2 border-b-2 border-gray-700 text-sm">
    <Link
      to={to}
      className="text-white hover:text-amber-500 transition block py-2 px-4 rounded-md"
    >
      {text}
    </Link>
  </li>
);

const SubMenu = ({ text, children }) => (
  <li className="mb-2">
    <span className="text-amber-500 hover:text-white transition font-bold block py-2 px-4 rounded-md">
      {text}
    </span>
    <ul className="pl-4">{children}</ul>
  </li>
);

export default Sidenav;
